import { render, staticRenderFns } from "./Fault.vue?vue&type=template&id=b5cacc88&scoped=true&"
import script from "./Fault.vue?vue&type=script&lang=js&"
export * from "./Fault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cacc88",
  null
  
)

export default component.exports